import React from 'react';
import { format } from 'date-fns';
import { useBookingConfig } from '@/lib/BookingConfigContext';
import { EXPERIENCE_DATA } from './bookingDefaults';

export default function BookingSummary({ experienceType, selectedDate, timeSlot }) {
  const { experiences } = useBookingConfig();
  const exp = experiences[experienceType] || EXPERIENCE_DATA[experienceType];

  const rows = [
    { label: 'Experience', value: exp?.name || '—' },
    { label: 'Date', value: selectedDate ? format(selectedDate, 'EEE dd MMM yyyy') : '—' },
    { label: 'Time', value: timeSlot || '—' },
    { label: 'Duration', value: '1 hour' },
  ];

  return (
    <div className="bg-[#111115] border border-white/5 p-6 self-start sticky top-28">
      <p className="text-primary text-[10px] font-bold tracking-widest mb-5">BOOKING SUMMARY</p>
      <div className="space-y-0">
        {rows.map((row) => (
          <div key={row.label} className="flex justify-between py-3 border-b border-white/5">
            <span className="text-white/40 text-sm">{row.label}</span>
            <span className="text-white text-sm font-medium text-right max-w-[60%]">{row.value}</span>
          </div>
        ))}
        <div className="flex justify-between items-center pt-5">
          <span className="text-white font-bold text-sm">TOTAL</span>
          <span className="text-primary font-black text-2xl">
            £{exp ? Number(exp.price).toFixed(2) : '0.00'}
          </span>
        </div>
      </div>
      <p className="text-white/20 text-[10px] mt-4 leading-relaxed">
        For sessions longer than 1 hour, please contact us at <span className="text-primary">sales@motionreality.co.uk</span>
      </p>
    </div>
  );
}